import localStorage from '@stubhub/local-storage';
import {Controller} from '@stubhub/react-store-provider';

import ACTIONS from './actions';
import {SELECTED_CURRENCY_STORAGE_KEY} from './config/constants';
import {
  advisoryEnabledSelector,
  currentLocaleSelector,
  defaultCurrencyCodesSelector,
  defaultLocaleSelector,
  selectedCurrencySelector,
  supportedCurrenciesSelector,
  supportedLocalesSelector,
} from './selectors';

const NAMESPACE = 'currencyExchange';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state, ownProps) {
    const {location: {search} = {}} = ownProps;

    return {
      isAdvisoryEnabled: advisoryEnabledSelector(state),
      defaultCurrencyCodes: defaultCurrencyCodesSelector(state),
      selectedCurrency: selectedCurrencySelector(state, search),
      supportedCurrencies: supportedCurrenciesSelector(state),
      defaultLocale: defaultLocaleSelector(state),
      currentLocale: currentLocaleSelector(state),
      supportedLocales: supportedLocalesSelector(state),
    };
  },
  actionCreators: {
    updateExchangeRate,
    updateSelectedCurrency,
    updateSupportedCurrencies,
  },
  reducers: [
    ACTIONS.EXCHANGE_RATE_UPDATE,
    ACTIONS.SELECTED_CURRENCY_UPDATE,
    ACTIONS.DEFAULT_CURRENCIES_UPDATE,
    ACTIONS.SUPPORTED_CURRENCIES_LOADED,
  ],
});

function updateExchangeRate(exchangeRate) {
  return (dispatch) => {
    dispatch({type: ACTIONS.EXCHANGE_RATE_UPDATE, exchangeRate});
  };
}

function updateSelectedCurrency(selectedCurrency) {
  return (dispatch) => {
    localStorage().setItem(SELECTED_CURRENCY_STORAGE_KEY, selectedCurrency);
    dispatch({type: ACTIONS.SELECTED_CURRENCY_UPDATE, selectedCurrency});
  };
}

function updateSupportedCurrencies(supportedCurrencies) {
  return (dispatch) => {
    dispatch({type: ACTIONS.SUPPORTED_CURRENCIES_LOADED, supportedCurrencies});
  };
}

export default controller;
